angular.module('gym').factory('PaymentProvidersService', ["$rootScope", function($rootScope) {
  var gym;
  gym = $rootScope.gym;
  return {
    get: function(paymentProvider) {
      switch (false) {
        case gym.payment_system !== paymentProvider:
          return gym.payment_system_account;
        case gym.secondary_payment_system !== paymentProvider:
          return gym.secondary_payment_system_account;
      }
    }
  };
}]);
